export enum IncludedModifierType {
	NO = 1,
	NORMAL = 0,
	LITE = 2,
	EXTRA = 3,
}
